import axios from "axios";
import { AllImmsCompletedForRoleCertificateModel, parseCertificateModel } from "@teamprevent/common/ppq/models";

const getAllImmsCompletedForRoleCertificate = async (employeeRecordId: string, ohCaseId: string, taskId: string) => {
    const response = await axios.get<AllImmsCompletedForRoleCertificateModel>(
        `/api/employeeRecord/${employeeRecordId}/ohCase/${ohCaseId}/task/${taskId}/allImmsCompletedForRoleCertificate`);
    return parseCertificateModel(response.data);
};

export const allImmsCompletedForRoleApi = { getAllImmsCompletedForRoleCertificate };
